export enum AuthenticationEnum {
  Public = 0,
  Private = 1
}
